import React from "react";
import { adsQuestions } from "../../configs/ads-questions";
import Accordion from "../upgrade/Accordion";

const AdQuestions = () => {
  return (
    <div className="bg-full-bleed-green">
      <div className="pt-20 pb-40">
        <div className="flex gap-12">
          <div className="flex flex-col w-1/2 gap-9">
            <div className="text-lg font-bold">Questions & Answers</div>
            <div className="text-5xl font-extrabold">Have Questions?</div>
            <div className="font-semibold leading-loose">
              Frequently Asked Questions About EasyDuct App Ads. We let you
              understand what is best for you and for your company to be shown
              in our app.
            </div>
          </div>
          <div className="flex flex-col w-1/2">
            {adsQuestions.map((question, index) => (
              <div key={index}>
                <Accordion props={question} />
              </div>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-4 mt-12 text-white gap-7">
          <div className="row-span-2 bg-[#80F730] home-sample-ads">
            <div className="flex items-center gap-3">
              <div className="ad-icon text-[#80F730]">Ad</div>
              <div className="ad-title">Large Vertical</div>
            </div>
            <div className="ad-price">$100</div>
            <div className="ad-desc">per 1000 {"IMP's"}</div>
          </div>
          <div className="col-span-3 bg-[#00DEA3] home-sample-ads">
            <div className="flex items-center gap-3">
              <div className="ad-icon text-[#00DEA3]">Ad</div>
              <div className="ad-title">Large Horizontal</div>
            </div>
            <div className="ad-price">$50</div>
            <div className="ad-desc">per 1000 {"IMP's"}</div>
          </div>
          <div className="bg-[#00CAD0] home-sample-ads">
            <div className="flex items-center gap-3">
              <div className="ad-icon text-[#00CAD0]">Ad</div>
              <div className="ad-title">1 Medium</div>
            </div>
            <div className="ad-price">$25</div>
            <div className="ad-desc">per 1000 {"IMP's"}</div>
          </div>
          <div className="bg-[#00B7FB] home-sample-ads">
            <div className="flex items-center gap-3">
              <div className="ad-icon text-[#00B7FB]">Ad</div>
              <div className="ad-title">2 Medium</div>
            </div>
            <div className="ad-price">$50</div>
            <div className="ad-desc">per 1000 {"IMP's"}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdQuestions;
